import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import { Typography } from '@mui/material'
import { intervalToDuration } from 'date-fns'
import sx from './styles'

const isSameDate = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear()
    && date1.getMonth() === date2.getMonth()
    && date1.getDate() === date2.getDate()
    && date1.getMilliseconds() === date2.getMilliseconds()
}

const AuctionCountdownTimer = ({
  auctionEnds,
  auctionStartAt,
  text,
  status,
  variant,
  onFinishedTimer,
}) => {
  const now = new Date()
  let timeout

  const [activeScond, setActiveScond] = useState(1)

  const duration = intervalToDuration({
    start: now,
    end: status === 'open' ? auctionEnds : auctionStartAt,
  })
  const auctionStartDuration = intervalToDuration({
    start: now,
    end: auctionStartAt,
  })

  useEffect(() => {
    if (isSameDate(now, auctionStartAt) && typeof onFinishedTimer === 'function') {
      onFinishedTimer()
    }
    if (now < auctionEnds) {
      timeout = setTimeout(() => {
        setActiveScond(activeScond + 1)
      }, 1000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [activeScond])

  const isTimerSrp = status === 'open' ? auctionEnds : auctionStartAt

  return (
    <>
      {
        status !== 'finished' && (
          <Grid
            sx={variant === 'srpVariant' ? sx.gridTimerSrp : sx.gridTimer}
          >
            {
              variant === 'srpVariant' ? (
                <Typography sx={sx.timerSrp}>
                  <FormattedMessage
                    id={text}
                    values={{
                      // day: `${now < isTimerSrp ? duration?.days : '0'}`,
                      hou: `${now < isTimerSrp ? duration?.hours : '0'}`,
                      min: `${now < isTimerSrp ? duration?.minutes : '0'}`,
                      sec: `${now < isTimerSrp ? duration?.seconds : '0'}`,
                    }}
                  />
                </Typography>

              ) : (
                <>
                  {
                    status === 'open' ? (
                      <Typography
                        sx={sx.timer}
                      >
                        <FormattedMessage
                          id={text}
                          values={{
                            // day: `${now < auctionEnds ? duration?.days : '0'}`,
                            hou: `${now < auctionEnds ? duration?.hours : '0'}`,
                            min: `${now < auctionEnds ? duration?.minutes : '0'}`,
                            sec: `${now < auctionEnds ? duration?.seconds : '0'}`,
                          }}
                        />
                      </Typography>
                    ) : (
                      <Typography
                        sx={status === 'scheduled' ? sx.timerPending : sx.timer}
                      >
                        <FormattedMessage
                          id="AUCTIONS_STARTS_TIME_TITLE"
                          values={{
                            // day: `${now < auctionStartAt ? auctionStartDuration?.days : '0'}`,
                            hou: `${now < auctionStartAt ? auctionStartDuration?.hours : '0'}`,
                            min: `${now < auctionStartAt ? auctionStartDuration?.minutes : '0'}`,
                            sec: `${now < auctionStartAt ? auctionStartDuration?.seconds : '0'}`,
                          }}
                        />
                      </Typography>
                    )
                  }
                </>
              )
            }
          </Grid>
        )
      }
    </>
  )
}

export default AuctionCountdownTimer
